var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('igt-feature',[_c('igt-boolean-setting',{attrs:{"setting":_vm.darkMode,"true-icon":"fa-moon","false-icon":"fa-sun"}}),_c('button',{staticClass:"btn btn-red",on:{"click":_vm.resetSave}},[_vm._v("Reset Save")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }